import { useQuery } from "@tanstack/react-query";
import { storiesClient } from "@core/clients";

const useGetStoriesQuery = () => {
  return useQuery(["stories"], async () => storiesClient.getStories());
};

export default useGetStoriesQuery;
  